module.exports = __webpack_public_path__ + "static/media/nft-19.d3281235.jpg";